import { SSO_OVERWRITE } from 'consts';
import { evolve } from 'ramda';
import { convertToNumberEmptyAsNull } from 'util/general';

export const addDerived = ({ ssoConfig, ...data } = {}) => {
  const overwrite = ssoConfig?.[SSO_OVERWRITE];

  if (overwrite && typeof overwrite === 'string') {
    try {
      ssoConfig[SSO_OVERWRITE] = JSON.parse(overwrite);
    } catch {
      // Invalid JSON, keep original string value
    }
  }

  return {
    ...data,
    ssoConfig,
  };
};

const importTransformations = {
  bpConfig: {
    bpExpediteFeeAmount: convertToNumberEmptyAsNull,
  },
  p2pConfig: {
    p2pRealtimeFeeAmount: convertToNumberEmptyAsNull,
  },
};

export const sanitizeForImport = (fspConfig) => {
  delete fspConfig?.id;
  delete fspConfig?.fspName;
  delete fspConfig?.products;
  delete fspConfig?.p2pConfig?.p2pPaynet;
  delete fspConfig?.checkConfig?.checkDeliverBizDays;
  delete fspConfig?.fspConfigKeyValue; // Business config values handled separately

  // Only billSavingPercent is supported under billSavingConfig
  fspConfig.billSavingConfig = {
    billSavingPercent: fspConfig?.billSavingConfig?.billSavingPercent,
  };

  return evolve(importTransformations, fspConfig);
};
